import http from  '../../Services/common/http-common'

class uploadExel{

   


    uploadWorkingHours(formDataBook: FormData) 
    {
        return http.post('/Excel/UploadWorkingHours', formDataBook, {
            headers: {
                'Content-Type' : 'multipart/form-data'
            }
        } )
    }


    upLoadWorkingHoursMty(formDataBook: FormData)
    {
        return http.post('/Excel/UploadWorkingHoursMty', formDataBook, {
            headers: {
                'Content-Type'   : 'multipart/form-data' 
            }
        } )
    }

    

}
export default new uploadExel()